/**
 * Bullet collision groups. Each value is a single bit so groups can be
 * combined with `|`. A body's `mask` lists the groups it collides with.
 */
export const GROUP = Object.freeze({
  DEFAULT: 1 << 0,
  VEHICLE: 1 << 1,
  PROP: 1 << 2,
  LEVEL: 1 << 3,
  TRIGGER: 1 << 4,
  BOUNDARY: 1 << 5,
  // Hitchhikers / pedestrians. Treated as immovable (kinematic) obstacles so a
  // vehicle that drives into one is stopped instead of passing through.
  PERSON: 1 << 6,
});

export const MASK = Object.freeze({
  ALL: -1,
  // The player vehicle collides with level geometry, props, closing boundaries
  // and anything else by default. It also collides with hitchhikers / pedestrians.
  VEHICLE: GROUP.LEVEL | GROUP.PROP | GROUP.DEFAULT | GROUP.BOUNDARY | GROUP.PERSON,
  // Props collide with everything solid.
  PROP: GROUP.LEVEL | GROUP.PROP | GROUP.VEHICLE | GROUP.DEFAULT,
  // Level geometry is static and collides with everything.
  LEVEL: GROUP.LEVEL | GROUP.PROP | GROUP.VEHICLE | GROUP.DEFAULT,
  // Pedestrians / hitchhikers: only the player vehicle should be stopped by them
  // (they must not fight the truck they are boarding, nor block raksha pickups).
  PERSON: GROUP.VEHICLE,
  // Camera and ground raycasts should not hit the vehicle itself.
  CAMERA: GROUP.LEVEL | GROUP.PROP,
  GROUND: GROUP.LEVEL | GROUP.PROP,
});
